<template>
    <v-dialog v-model="dialogOpen"
              persistent
              max-width="400px">
        <v-card>
            <toolbar-page title="Delete confirmation" disable-icon>
                <template slot="buttons">

                    <v-tooltip top color="primary">
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" @click="dialogOpen=false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Close</span>
                    </v-tooltip>
                </template>

            </toolbar-page>

            <v-card-text>

                <v-alert type="error" class="body-2">
                    Confirm that you really want to delete this tenant by entering Tenant't panel name
                    name in the box below
                </v-alert>

                <v-sheet color="grey" class="pa-3 text-center title">
                    {{ tenant.panel_name }}
                </v-sheet>

                <v-text-field
                        ref="textfield"
                        class="pt-3"
                        v-model="panelName"
                        label="Enter tenant's panel name"
                        @keyup="checkName"
                ></v-text-field>

            </v-card-text>

            <v-card-actions>
                <v-btn :disabled="!correct" color="primary" @click="confirmed">Confirm</v-btn>
                <v-btn color="secondary" @click="closeDialog">Cancel</v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>

    import ToolbarPage from '../../../components/UI/ToolbarPage';

    export default {

        components: {
            ToolbarPage
        },

        props: {
            value: {
                type: Boolean,
                default: false,
                required: true
            },

            tenant: {
                type: Object,
                required: false,
                default: () => ({
                    updated_at: null,
                    created_at: null,
                    uuid: null,
                    fqdn: null,
                    trial_expires_on: null,
                })
            }
        },

        data() {
            return {
                panelName: null,
                correct: false,
            }
        },

        watch: {
            value(bool) {
                if (bool) {
                    this.panelName = '';
                    this.correct = false;
                    this.$nextTick(() => this.$refs.textfield.focus());
                }
            }
        },

        computed: {
            dialogOpen: {
                get() {
                    return this.value;
                },
                set() {
                    this.closeDialog();
                }
            }
        },

        methods: {

            closeDialog() {
                this.$emit('input', false);
            },

            checkName() {
                this.correct = this.panelName === this.tenant.panel_name;
            },

            confirmed() {
                this.$emit('change', Object.assign({}, this.tenant));
            }
        },
    }
</script>
